import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

const Container = styled.div`
  grid-area: image;
  align-self: center;
  justify-self: center;
`;

const Image = styled.img`
  max-width: 25px;
  max-height: 1rem;
`;

const IconLogo = styled(Icon)`
  font-size: 12px;
`;

export default ({ logo_type, logo }) => (
  <Container>
    {logo_type === 'credit_card' ? (
      <Image src={`/images/payment-icons/${logo}.png`} />
    ) : logo_type === 'bank_institution' ? (
      <Image src={logo} />
    ) : logo_type === 'bank_default' ? (
      <IconLogo name="university" />
    ) : logo_type === 'internal' ? (
      <IconLogo name="user-circle" />
    ) : null}
  </Container>
);
